import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ironBuildVersionIsV4 } from '@app/utils';

import type { LanguageObject } from '../types';
import { LANGUAGES } from '../data';

const useCurrentLanguage = (): LanguageObject => {
  const {
    i18n: { language },
  } = useTranslation();

  const langObject = useMemo(() => {
    if (ironBuildVersionIsV4) {
      // in next the language is the url which differs our old way
      const foundLang = Object.values(LANGUAGES).find(
        ({ url, value }) => url === language || value === language,
      );

      if (foundLang) {
        return foundLang;
      }

      return LANGUAGES.en;
    }

    return LANGUAGES[language];
  }, [language]);

  return langObject;
};

export default useCurrentLanguage;
